import React from "react";
import { Typography, Row, Button, Spin } from "antd";
import moment from "moment-jalaali";
import "./OrderPageView.css"
import PaymentCard from "./PaymentCard";
import Currency from "components/Currency";
import { useHistory } from "react-router";
import routesConfig from "routesConfig";

export default function OrderPageView(props) {
    const { purchaseInfo, onPaymentClick, paymentGateways, submitting } = props;
    const history = useHistory()
    let createOrderDate = (startTime) => {
        const tripStartTime = moment(startTime);
        return tripStartTime.format('jYYYY/jM/jD')
    }
    let createOrderStartHour = (startTime) => {
        const tripStartTime = moment(startTime);
        return tripStartTime.format('HH:mm')
    }

    function getRideSpec() {
        let rideEndTime = new Date(purchaseInfo.rideDetail.startTime);
        rideEndTime.setSeconds(rideEndTime.getSeconds() + purchaseInfo.rideDetail.duration);
        const durationMnts = Math.ceil(purchaseInfo.rideDetail.duration / 60.0)
        return <>
            <Typography level={4} className='f-22 mb-1 mt-0'> {purchaseInfo && 'مشخصات سفر'}</Typography>
            <Row className='order-time-section'>
                <p className='f-14 m-0 c-light-grey'>{purchaseInfo && 'تاریخ سفر'}</p>
                <p className='f-14 mr-auto mb-0 c-light-grey'>
                    {purchaseInfo && createOrderDate(purchaseInfo.rideDetail.startTime)}
                </p>
            </Row>
            <Row className='order-time-section mb-1'>
                <p className='f-14 m-0 c-light-grey'>{purchaseInfo && 'ساعت شروع - پایان'}</p>
                <p className='f-14 mr-auto mb-0 c-light-grey'>
                    {purchaseInfo && createOrderStartHour(purchaseInfo.rideDetail.startTime)
                        + '-' +
                        createOrderStartHour(rideEndTime)
                    }
                </p>
            </Row>
            <Row className='order-time-section mb-36'>
                <p className='f-16 m-0'>{purchaseInfo && 'مجموع زمان در اختیار'}</p>
                <p className='f-16 mr-auto mb-0'>
                    {durationMnts + ' دقیقه'}
                </p>
            </Row>
        </>;
    }

    function getRidePaymentDetails() {
        let totalCost = purchaseInfo.priceDetails.reduce(function (prev, cur) {
            return prev + cur.value;
        }, 0);
        let totalDiscount = purchaseInfo.discountDetails.reduce(function (prev, cur) {
            return prev + cur.value;
        }, 0);
        return <>
            <Row className='clearfix'>
                <div className='f-16'>مجموع هزینه سفر</div>
                <div className='f-16 mr-auto'>
                    <Currency value={totalCost} />
                </div>
            </Row>
            <Row className='mb-1 clearfix'>
                <div className='f-16'>تخفیف</div>
                <div className='f-16 mr-auto'>
                    <Currency value={totalDiscount} />
                </div>
            </Row>
        </>;
    }

    const acitvateFree = () => {
        if (purchaseInfo.paid) {
            history.push(routesConfig.home)
        } else {
            onPaymentClick(purchaseInfo.id, "RoroWalletPay")
        }
    }

    const shouldPay = purchaseInfo && purchaseInfo.totalPrice > 0 && !purchaseInfo.paid

    return <div className='order px-40'>
        <Typography level={3} className=' f-30 mt-0 mb-36 f-bold'>{purchaseInfo && purchaseInfo.title}</Typography>
        {purchaseInfo.purchaseType === "RIDE" ? getRideSpec() : null}
        {purchaseInfo.purchaseType === "RIDE" ?
            <Typography level={4} className='f-22 mb-1 mt-0'> {purchaseInfo && 'هزینه سفر'}</Typography> : null
        }
        <div className='mb-1'>
            {purchaseInfo && purchaseInfo.priceDetails &&
                purchaseInfo.priceDetails.map((priceDetail, key) => <Row className='' key={key}>
                    <span className='f-16 c-light-grey'>{priceDetail.title}</span>
                    <span className='f-16 c-light-grey mr-auto'><Currency value={priceDetail.value} /></span>
                </Row>)}
            {
                purchaseInfo && purchaseInfo.discountDetails &&
                purchaseInfo.discountDetails.map((discountDetail, key) => <Row className='mb-1' key={key}>
                    <span className='f-16 c-light-grey'>{discountDetail.title}</span>
                    <span className='f-16 c-light-grey mr-auto'><Currency value={discountDetail.value} /></span>
                </Row>)
            }
        </div>
        <div className=''>
            {purchaseInfo.purchaseType === "RIDE" ? getRidePaymentDetails() : null}
            <Row className='mb-1 clearfix'>
                <div className='f-18'>مبلغ قابل پرداخت</div>
                <div className='f-18 mr-auto'>
                    <Currency value={purchaseInfo.totalPrice} />
                </div>
            </Row>
            {submitting && <Row className="clearfix m-3"><Spin /></Row>}
            {!submitting && shouldPay && paymentGateways.map(paymentGateway => <PaymentCard
                key={'pg-' + paymentGateway.paymentGatewayId}
                paymentClick={(e) => onPaymentClick(purchaseInfo.id, paymentGateway.paymentGatewayId)}
                paymentGateway={paymentGateway} />)}
            {!submitting && !shouldPay && <Button type="primary" block
                onClick={acitvateFree} >
                تایید
            </Button>}
        </div>
    </div>;
}